export default __webpack_public_path__ + "static/media/trampapo_01-11.18d00b9a.png";